import { ApiID } from '@/model/Common.model';
import type { SelectOption } from '@/components/UI/Select/Select';
import {
  AnalysisConfig,
  AnalysisIssue,
  AnalysisOptions,
  AnalysisType,
  AverageType,
  TrackingFrom,
} from '@/model/Analysis.model.ts';

export interface ProcessedAnalysisConfig {
  measurements: Set<AnalysisConfig['measurements'][0]>;
  average_type: Set<AnalysisConfig['average_type'][0]>;
  tracking_from: Set<AnalysisConfig['tracking_from'][0]>;
}

export interface AnalysisState {
  options?: AnalysisOptions;
  config?: Map<AnalysisType, ProcessedAnalysisConfig>;
  issues?: Array<AnalysisIssue>;
  exportSnapshotApiId?: ApiID<'esh'>;
}

export const analysisTypeOptions: Record<AnalysisType, SelectOption<AnalysisType>> = {
  Efficacy: { value: 'Efficacy', label: 'Efficacy' },
  EfficacyProphylactic: { value: 'EfficacyProphylactic', label: 'Efficacy Prophylactic' },
  ToleranceSurvival: { value: 'ToleranceSurvival', label: 'Tolerance and Survival' },
  Survival: { value: 'Survival', label: 'Survival' },
  Tolerance: { value: 'Tolerance', label: 'Tolerance' },
  Oncology: { value: 'Oncology', label: 'Oncology Summary' },
};

export const averageTypeOptions: Record<AverageType, SelectOption<AverageType>> = {
  Mean: { value: 'Mean', label: 'Mean' },
  Median: { value: 'Median', label: 'Median' },
};

export const analysisDayFromOptions: Record<TrackingFrom, SelectOption<TrackingFrom>> = {
  TrackingDay: { value: 'TrackingDay', label: 'from tracking date' },
  DiseaseInduction: { value: 'DiseaseInduction', label: 'from disease induction' },
};
